import React from "react";

import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

const SocialLinks = () => (
  <>
    <a href="https://twitter.com/bdnews24com" target="_blank" rel="noreferrer" aria-label="twitter icon">
      <SvgIconHandler type="twitter" width="24" height="24" viewBox="0 0 24 24" className="twitter-icon" />
    </a>
    <a href="https://www.facebook.com/bdnews24/" target="_blank" rel="noreferrer" aria-label="facebook icon">
      <SvgIconHandler type="facebook" width="24" height="24" viewBox="0 0 24 24" className="fb-icon" />
    </a>
    <a href="https://www.youtube.com/user/bdnews24DOTcom" target="_blank" rel="noreferrer" aria-label="youtube icon">
      <SvgIconHandler type="youtube" width="24" height="24" viewBox="0 0 24 24" className="youtube-icon" />
    </a>
    <a href="https://www.instagram.com/bdnews24/" target="_blank" rel="noreferrer" aria-label="instagram icon">
      <SvgIconHandler type="instagram" width="24" height="24" viewBox="0 0 24 24" />
    </a>
  </>
);

export default SocialLinks;
